import { MenuItemUnion } from 'packages/web-layout/types'

import { useActivitiesMenu } from './activities/menu'
import { useAdmissionsMenu } from './admissions/menu'
import { useGatewayManagementMenu } from './gatewayManagement/menu'
import { useHotNewsAdminMenu } from './hot-news/menu'
import { useStudentManagementMenu } from './studentManagement/menu'
import { useSystemSettingMenu } from './systemSetting/menu'
import { useTeacherManagementMenu } from './teacherManagement/menu'
import { useTestPaperMenu } from './test-paper/menu'

/**
 * 侧边栏头部的菜单定义
 *
 * @returns 菜单定义
 */
export const useSiderMenus: () => MenuItemUnion[] = () => [
  ...useActivitiesMenu(),
  ...useAdmissionsMenu(),
  ...useStudentManagementMenu(),
  ...useTeacherManagementMenu(),
  ...useTestPaperMenu(),
  ...useGatewayManagementMenu(),
  ...useHotNewsAdminMenu(),
  ...useSystemSettingMenu(),
]
